'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
const StyledUIButton = styled(UIButton).withConfig({
  displayName: "ExpandableFilter__StyledUIButton",
  componentId: "sc-1pkzz0i-0"
})(["&&{text-align:left;}"]);

const ExpandableFilter = ({
  children,
  name,
  defaultDisplayCount = 5
}) => {
  const [showAll, setShowAll] = useState(false);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": `${name} filter results`,
      children: /*#__PURE__*/_jsx(UIToggleGroup, {
        name: name,
        children: children.take(showAll ? Infinity : defaultDisplayCount)
      })
    }), !showAll && children.size > defaultDisplayCount && /*#__PURE__*/_jsx(StyledUIButton, {
      use: "transparent",
      className: "p-left-0",
      onClick: () => setShowAll(true),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.expandableFilter.expandButtonText"
      })
    })]
  });
};

ExpandableFilter.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  defaultDisplayCount: PropTypes.number
};
export default ExpandableFilter;